var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5703_38688",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5703_38688)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5703_38688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04962 7.19494L7.85462 10.5429L11.2446 6.36894C11.3395 6.25225 11.4596 6.15848 11.5958 6.09461C11.732 6.03075 11.8808 5.99843 12.0312 6.00006C12.1816 6.00169 12.3297 6.03724 12.4645 6.10405C12.5993 6.17086 12.7173 6.26722 12.8096 6.38594L16.0446 10.5419L19.9726 7.14594C20.1269 7.01285 20.3181 6.93005 20.5207 6.90863C20.7233 6.8872 20.9276 6.92816 21.1063 7.02604C21.285 7.12392 21.4295 7.27404 21.5205 7.45631C21.6116 7.63858 21.6447 7.8443 21.6156 8.04594L20.1156 18.3929H3.92262L2.39962 8.09294C2.36937 7.89018 2.40217 7.68302 2.49357 7.49951C2.58498 7.31601 2.73057 7.16503 2.91064 7.06703C3.09071 6.96903 3.29655 6.92874 3.50027 6.95162C3.704 6.9745 3.89578 7.05944 4.04962 7.19494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2043 6.07892L16.1158 9.81942L19.72 6.7C19.72 6.7 20.5 6.04 21.5 6.68C22.03 7.15 22.09 7.39859 22.13 7.99C21.62 11.59 20.54 18.9 20.54 18.9L3.49 18.89L1.90504 8.16635C1.85976 7.86232 1.90897 7.55172 2.04602 7.27658C2.18313 7.00133 2.40152 6.77486 2.67163 6.62786C2.94173 6.48086 3.25048 6.42043 3.55608 6.45475C3.86159 6.48906 4.14937 6.61657 4.3801 6.81973L7.79442 9.82397L10.8568 6.05342C10.9991 5.87838 11.1792 5.73773 11.3835 5.64192C11.5878 5.54612 11.811 5.49764 12.0367 5.50009C12.2623 5.50254 12.4844 5.55586 12.6866 5.65608C12.8887 5.75628 13.0657 5.90088 13.2043 6.07892Z",
    stroke: "#242129",
    strokeOpacity: 0.27
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5703_38688",
    x: -2.61133,
    y: 1,
    width: 29.2441,
    height: 22.4002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5703_38688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5703_38688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown-icon.2b8c03497592c48054ff8aaceaa92a1a.svg";
export { ForwardRef as ReactComponent };